import component from './tags.component';
import service from './tags.service';

export default angular.module('mpdx.contacts.tags', [component, service]).name;
